import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {TextBox} from '../../../../libs/shared/ui/src/components/boxedInputs/textBox';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {useBaseEditorContext} from '../../editors/baseEditorContext';
import {EditorStateActions} from './hooks/useEditorState';

/*
 * Props.
 */

interface RuleEditorRuleNameInputProps {
  ruleName: string;
  onUpdateRuleName: EditorStateActions['onUpdateRuleName'];
}

/*
 * Styles.
 */

const StyledTextBoxWrapper = styled.div`
  width: 530px;
  margin-bottom: 40px;
`;

/*
 * Component.
 */

export const RuleEditorRuleNameInput: FC<RuleEditorRuleNameInputProps> = ({ruleName, onUpdateRuleName}) => {
  const {isReadOnly} = useBaseEditorContext();

  return (
    <StyledTextBoxWrapper>
      <TextBox
        value={ruleName}
        onChange={onUpdateRuleName}
        size={VisualSizesEnum.LARGE}
        noMargin
        label={<Trans id="rule-editor-rule-name-label">Name</Trans>}
        placeholder="Enter a name for this rule"
        isDisabled={isReadOnly}
        shouldAutoFocus
      />
    </StyledTextBoxWrapper>
  );
};
